import { Plus } from 'lucide-react'
import { agentsFaqs } from '@/features/agents-marketing/data/agentsContent'
import { SectionHeading } from '@/features/home/components/SectionHeading'
import { Reveal } from '@/shared/components/Reveal'

export function AgentsFaq() {
  return (
    <section className="relative w-full px-6 py-24 md:py-36">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <SectionHeading eyebrow="FAQ" title="Common questions." />
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-8">
          <div className="divide-y divide-[var(--color-border)] border-y border-[var(--color-border)]">
            {agentsFaqs.map((faq) => (
              <details key={faq.question} className="group py-6">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-6 font-medium text-[var(--color-text-primary)] transition-colors duration-300 ease-brisk hover:text-primary [&::-webkit-details-marker]:hidden">
                  {faq.question}
                  <Plus
                    aria-hidden
                    className="size-4 shrink-0 text-[var(--color-text-tertiary)] transition-transform duration-300 ease-brisk group-open:rotate-45"
                    strokeWidth={1.75}
                  />
                </summary>
                <p className="mt-3 max-w-2xl pr-10 text-body-sm leading-relaxed text-[var(--color-text-secondary)]">
                  {faq.answer}
                </p>
              </details>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  )
}
